module.exports = __webpack_public_path__ + "assets/svg/Icons/32/announcement-blue-c48fa0.svg";